import React from 'react';
import type { RouteObject } from 'react-router-dom';

const FavoritesPage = React.lazy(() => import('@/pages/favorites'));

export const favoritesRoutes: RouteObject[] = [
  {
    path: 'favorites',
    element: <FavoritesPage />,
  },
];
